<template>
  <section v-if="products.length">
    <h4 class="mt-8 mb-4 font-semibold text-xl uppercase">Ähnliche Produkte</h4>

    <div class="flex flex-wrap p-3 lg:p-0 -m-0 lg:-m-2">
      <ProductCard
        v-for="product in products"
        :key="product.id"
        shop
        :full-width="fullWidth"
        :href="product.url"
        :sale="product.sale"
        :bestseller="product.bestseller"
        :news="product.news"
        :product="product"
        class="wow fadeIn"
      >
        <template slot="category">
          {{ product.groups[0] }}
        </template>
        <template slot="name">
          {{ product.title }}
        </template>
        <template slot="price">
          {{ product.price | currency }}
        </template>
        <template
          v-if="product.price_old && product.price_old > product.price"
          slot="oldprice"
        >
          {{ product.price_old | currency }}
        </template>
      </ProductCard>
    </div>
  </section>
</template>

<script>
import ProductCard from '~/components/cardtypes/ProductCard'

export default {
  components: {
    ProductCard,
  },

  props: {
    products: {
      type: Array,
      required: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {},

  methods: {},
}
</script>

<style></style>
